<template>
	<div>
		<c-dialog ref="dialog" width="650" mode="slide" mask-close @close="dialogFormEditConfirm($refs.outputForm, arguments)" @resolve="editHandle">
			<c-form ref="outputForm" unit-width="100%">
				<!--标准产量 公式计算支持-->
				<c-input type="hidden" name="unit_duration_count" decimal="6" :range="[0,99999999]" v-model="unit_duration_count" disabled></c-input> 
				<c-input type="hidden" name="unit_duration_hours" decimal="6" :range="[0,99999999]" v-model="unit_duration_hours" disabled></c-input> 
				<c-input type="hidden" name="unit_duration_minutes" decimal="6" :range="[0,99999999]" v-model="unit_duration_minutes" disabled></c-input> 
				<c-input type="hidden" name="price" decimal="6" :range="[0,99999999]" v-model="price" disabled></c-input>
				<c-input type="hidden" name="output_type"></c-input>
				<c-input type="hidden" name="rework_after_type"></c-input>
				
				<c-form-item label="工单编号" required>
					<c-select name="work_id" async v-model="work_id" @search="searchWork" :value-data="workOptions" @change="changeWork" :disabled="this.editState" :clear="false">
						<template #option="{data, selected}">
							<select-option
								:name="data.name"
								:info="[
									`${data.data.product_code} | ${data.data.product_name} | ${data.data.product_spec}`
								]"
								:selected="selected"
							></select-option>
						</template>
					</c-select>
					<info-card code="WORK_PRODUCT" :id="work_id"></info-card>
				</c-form-item>
				<c-form-item label="工序" required>
					<c-select name="task_id" v-model="task_id" :options="taskOptions" @change="changeTask" :disabled="work_id==0||this.editState" :clear="false">
                        <template #option="{data, selected}">
                            <select-option
                                :name="data.name"
                                :image="data.process_image"
                                :selected="selected"
                            ></select-option>
                        </template>
                    </c-select>
					<info-card code="TASK_STATISTICS" :id="task_id"></info-card>
					
					<div v-if="outputType != 1 || testMode != 1" class="output-tag flex">
						<div v-if="outputType != 1" class="flex-center flex-grow">
							<label>报工类型：</label>
							<c-state dict="outputTypeDic" :value="outputType"></c-state>
						</div>
						<div v-if="testMode != 1" class="flex-center flex-grow">
							<label>质检方式：</label>
							<c-state dict="testModeDic" :value="testMode"></c-state>
						</div>
					</div>
				</c-form-item>
				
				<c-form-item label="任务状态" :tip="work_state!=2?'工单非『执行中』不允许变更任务状态':''">
					<c-radio-group v-model="taskState" name="taskState" :options="orderStateNoCancelDic" @change="changeTaskState($event)" :disabled="task_id==0||!auth('b_task_edit_state')||work_state!=2"></c-radio-group>
				</c-form-item>
				<c-form-item label="生产人员" required>
					<c-select name="output_user_id" async @search="searchOutputUser" v-model="output_user_id" @change="changeOutputUser" :value-data="outputUserOptions" :disabled="!task_id" :clear="false"></c-select>
				</c-form-item>
				<c-form-item label="良品数" required name="counts">
					<c-input type="number" name="aux_fine_count" decimal="6" :range="[0,99999999]" v-model="aux_fine_count" :append-text="aux_unit" @blur="changeOutputCount"></c-input>
					<c-input type="hidden" name="aux_unit_count" decimal="6" :range="[0,99999999]" v-model="aux_unit_count" disabled></c-input> 
					<c-input type="hidden" name="fine_count" decimal="6" :range="[0,99999999]" v-model="fine_count" disabled  :append-text="unit"></c-input> 
				</c-form-item>

				<c-form-item v-show="systemConfig.output_field_defects_count != '0'" label="不良品数" required>
					<c-input type="number" name="aux_defects_count" decimal="6" :range="[0,99999999]" v-model="aux_defects_count" :append-text="aux_unit" @blur="changeOutputCount"></c-input>
					<c-input type="hidden" name="aux_unit_count" decimal="6" :range="[0,99999999]" v-model="aux_unit_count" disabled></c-input> 
					<c-input type="hidden" name="defects_count" decimal="6" :range="[0,99999999]" v-model="defects_count" disabled  :append-text="unit"></c-input> 
				</c-form-item>
				<c-form-item v-show="systemConfig.output_field_defects_count != '0'" label="不良品项" name="defects">
					<c-select ref="defectsList" name="defects_list" multiple :disabled="task_id==0" @customEvent="editDefects"></c-select>
				</c-form-item>
				
				<custom-form ref="customForm" work-type="14"></custom-form>

				<form-link v-show="systemConfig.output_field_duration != '0' || systemConfig.output_field_date != '0'" v-model="durationDateLink" :disabled="systemConfig.output_field_duration == '0' || systemConfig.output_field_date == '0'">
					<c-form-item v-show="systemConfig.output_field_duration != '0'" label="报工时长" required>
						<c-grid-row gap column="2">
							<c-grid-col>
							<c-input type="stepper" stepControls="side" name="duration_hours" :range="[0,262800]" append-text="小时" :clear="false" v-model="duration_hours" @change="changeHoursMinutes"></c-input>
							</c-grid-col>
							<c-grid-col>
							<c-input type="stepper" stepControls="side" name="duration_minutes" :range="[0,59]" append-text="分钟" :clear="false" v-model="duration_minutes" @change="changeHoursMinutes"></c-input>
							</c-grid-col>
						</c-grid-row>
					</c-form-item>
					<c-form-item v-show="systemConfig.output_field_date != '0'" label="报工时间" required>
						<c-datetime start-name="real_start_date" end-name="real_end_date" type="datetime" range time-accuracy="min" :clear="false" format="yyyy-MM-dd hh:mm" v-model="real_date" @change="changeRealDate"></c-datetime>
					</c-form-item>
				</form-link>

				<c-form-item v-show="systemConfig.output_field_pricing_type != '0' && systemConfig.edit_pricing_type == 1" label="计价方式" required>
					<c-radio-group name="pricing_type" v-model="pricing_type" :options="pricingTypeDic" @change="changeOutputPricingType($event)" :disabled="!systemConfig.edit_pricing_type || systemConfig.edit_pricing_type=='0'"></c-radio-group>
				</c-form-item>

				<c-form-item v-show="systemConfig.output_field_pricing_type != '0' || systemConfig.output_field_salary != '0'" :label="systemConfig.output_field_salary != '0' ? '工资绩效' : '计价方式'">
					<div class="salary-bar flex-between-center">
						<p class="flex-center">
							<i class="tf-salary"></i>
							<c-state v-show="systemConfig.output_field_pricing_type != '0'" dict="pricingTypeDic" :value="pricing_type"></c-state>
						</p>
						<p v-show="systemConfig.output_field_salary != '0'">
							<span v-show="systemConfig.output_field_salary_type != 1">工资单价：<span style="color: #FF1414;">{{price}}元</span><ins>|</ins></span>
							<span>预计工资：<b>{{salary}}元</b></span>
						</p>
					</div>
					<template v-if="systemConfig.output_field_salary != '0'" #handle>
						<c-refresh class="flex-center" color="main" @click="getOutputPriceConfig()"></c-refresh>
					</template>
				</c-form-item>
				
				<c-form-item v-show="systemConfig.output_field_apply_state != '0'" label="审批状态">
					<c-radio-group v-if="auth('b_output_audit')" name="state" :options="auditState2Dic"></c-radio-group>
					<c-select v-else name="state" :options="auditState2Dic" :disabled="true"></c-select>
				</c-form-item>
				
				<c-form-item v-if="systemConfig.output_notice == 1" label="通知人员">
					<c-select name="notify_user_list" async :multiple="{limit:10,linefeed:true}" @search="searchNotifyUser" :value-data="notifySelectedUser" :disabled="!task_id"></c-select>
				</c-form-item>
			</c-form>
		</c-dialog>

		<c-dialog ref="defectsEdit" title="添加不良品项" width="500" height="400" enable-flex @resolve="editDefectsHandle">
			<c-table ref="defectsEditList" height="grow" :paging="false">
				<c-table-column
					type="selector"
					:selected="({data}) => data.selected"
					width="32"
				></c-table-column>

				<c-table-column
					label="不良品项"
					name="defects_name"
					width="300"
				></c-table-column>

				<c-table-column
					label="数量"
					width="140"
				>
					<template #default="{data}">
						<c-input v-model="data.item_count" type="stepper" :range="[0,99999999]" decimal="6" @change="changeCount(data)"></c-input>
					</template>
				</c-table-column>
			</c-table>
		</c-dialog>
	</div>
</template>

<script>
import formLink from '@/components/public/form_link.vue'
import {mapState} from "vuex";

export default {
	name: 'outputEdit',

	components: {
		formLink
	},

	props: {
		byTask: Boolean
	},
	
	data() {
		return {
			durationDateLink: true,
			outputType: 1,
			testMode: 1,

			editState: false,       //是否运行编辑  true= 允许  false=不允许
			taskState:0,
			work_id:0,
			work_state:0,
			task_id:0,
			process_id:0,
			output_id: 0,
			workOptions:[],
			taskOptions: [],
			outputUserOptions: [],
			duration_minutes:0,
			duration_hours:0,
			real_date:[],
			aux_fine_count:0,	//良品数
			fine_count:0,		//产品良品数
			aux_defects_count:0,	//不良品数
			defects_count:0,		//产品不良品数
			output_user_id:0, //报工人
			pricing_type:1, //计价方式（1：计件，2：计时）
			
			unit_duration_count: 0,		//标准产量
			unit_duration_hours: 0,		//标准工时（小时）
			unit_duration_minutes: 0,	//标准工时（分钟）
			
			unit:'',
			aux_unit_id: 0,
			aux_unit: '',
			aux_unit_count: '',

			price: 0,
			salary: 0,
			
			notifySelectedUser: []
		}
	},

	computed: {
		// 获取dictName选项数据
		...mapState(['userInfo', 'systemConfig', 'orderStateNoCancelDic', 'pricingTypeDic', 'auditState2Dic', 'testModeDic', 'outputTypeDic'])
	},

	methods: {
		//输入报工时长小时、分钟
		changeHoursMinutes(){
			if (!this.durationDateLink) return;
			var currentTime = new Date(this.real_date[1]);
			var real_start_date = new Date(currentTime.getTime() - (this.duration_hours * 60 * 60 * 1000) - (this.duration_minutes * 60 * 1000)).format('yyyy-MM-dd hh:mm');
			var real_end_date = new Date(currentTime).format('yyyy-MM-dd hh:mm');
			this.real_date = [real_start_date, real_end_date];
			// console.log("小时变化");
		},
		
		//报工时间选择
		changeRealDate(data){
			if (!this.durationDateLink) return;
			const start = new Date(data[0]);
			const end = new Date(data[1]);
			const difference = end - start; // 时间差，单位毫秒
			// 转换为小时和分钟
			const hours = Math.floor(difference / 3600000);
			const minutes = Math.floor((difference % 3600000) / 60000)
			this.duration_hours = hours;
			this.duration_minutes = minutes;
		},
		
		//报工数变更
		changeOutputCount(){
			this.fine_count = this.aux_fine_count * this.aux_unit_count;
			this.defects_count = this.aux_defects_count * this.aux_unit_count;
		},
		
		/************通过任务打开新增报工弹窗**************/
		openByTask(data) {
			this.editState = false;
			this.outputType = this.testMode = 1;
			this.$refs.outputForm.clear();
			this.initCustomForm();
			this.output_id = 0;
			this.unit = data.unit;
			//初始默认数据
			this.initData();
			
			//获取默认填入的良品数
			let de_fine_count = this.getDefFineCount(data);
			
			//按任务初始数据
			this.outputType = 1;
			this.testMode = data.test_mode;
			this.$refs.outputForm.set({
				product_code: data.product_code,
				product_name: data.product_name,
				product_spec: data.product_spec||'-',
				work_id: data.work_id,
				taskState: data.state,
				fine_count: de_fine_count,
				defects_count: 0,
				aux_defects_count:0
			});
			this.work_id = data.work_id;
			this.work_state = data.work_state;
			
			//处理选中工单信息
			this.workOptions = [{
				name: data.work_code,
				value: data.work_id
			}];
			//初始化任务列表，并选中
			this.initTaskOption({
				task_id: data.id,
				fine_count: de_fine_count,
				process_id: data.process_id,
				product_id: data.product_id,
				process_code: data.process_code,
				process_name: data.process_name
			});
			this.setLinkedData();
			
			this.$refs.dialog.open({
				title: '创建报工'
			});
			this.durationDateLink = true;
		},
		
		/************打开新增/编辑报工弹窗**************/
		open(data) {
			if (this.byTask) {
				this.openByTask(data);
				return;
			}
			this.editState = !!data;
			this.outputType = this.testMode = 1;
			this.$refs.outputForm.clear();
			this.initCustomForm();
			if (data) {
				this.output_id = data.id;
				this.getDetail();
			}else {
				this.output_id = 0;
                //初始默认数据
				this.initData();
			}
			this.$refs.dialog.open({
				title: data ? (data.state==0?'提交报工':'编辑报工') : '创建报工'
			});
			this.durationDateLink = true;
		},
		
		//初始默认数据
		initData(){
			this.taskOptions = [];
			
			var state = 1;
			//判断是否有审批权限，如果有权限，则默认为已审批
			if(this.auth('b_output_audit')){
				state = 2;
			}
			
			this.$refs.outputForm.set({
				aux_fine_count:0,
				fine_count:0,
				defects_count: 0,
				aux_defects_count: 0,
				real_start_date: new Date().format('yyyy-MM-dd hh:mm'),
				real_end_date: new Date().format('yyyy-MM-dd hh:mm'),
				duration_hours:0,
				duration_minutes:0,
				pricing_type: this.userInfo.pricing_type,
				state:state
			});

			this.price = this.salary = 0;

			//处理选中员工信息
			this.outputUserOptions = [{
				name: this.userInfo.user_realname,
				value: this.userInfo.id
			}];
		},

		initCustomForm() {
			this.$refs.customForm.init({
				formulaSource: {
					'报工': {
						form: this.$refs.outputForm,
						watch: {
							'work_id': (data, resolve) => {
								data.work_id && this.request({
									url: '/work/overview',
									data: {
										id: data.work_id
									},
									success: data => {
										resolve({
											'工单': data.detailInfo
										});
									}
								});
							},
							'task_id': (data, resolve) => {
								data.task_id && this.request({
									url: '/task/detail',
									data: {
										id: data.task_id
									},
									success: data => {
										resolve({
											'任务': data
										});
									}
								});
							}
						},
						update: data => {
							this.getOutputPriceConfig(data);
						}
					}
				}
			});
		},

		/*******搜索报工详情*******************/
		getDetail() {
			this.request({
				url:'/output/detail',
				data: {
					id: this.output_id
				},
				loading: true,
				success: data => {
					data.detailInfo.product_spec = data.detailInfo.product_spec||'-'
					//工单基本信息
					this.outputType = data.detailInfo.output_type;
					this.testMode = data.detailInfo.output_type;
					this.$refs.outputForm.set(data.detailInfo);
					this.$refs.outputForm.set({taskState: data.taskInfo.state});
					//初始工单ID
					this.work_id = data.taskInfo.work_id;
					this.work_state = data.taskInfo.work_state;
					//处理选中工单信息
					this.workOptions = [{
						name: data.taskInfo.work_code,
						value: data.taskInfo.work_id
					}];
					
					//处理已选中的不良品项
					var selectDefectsDatas = data.defectsList.map(item => {
						return item.id
					});
					
					//初始化任务列表，并选中
					this.initTaskOption({
						task_id: data.detailInfo.task_id,
						fine_count: data.detailInfo.fine_count,
						process_id:data.taskInfo.process_id,
						process_code:data.taskInfo.process_code,
						process_name:data.taskInfo.process_name,
						selectDefectsDatas: selectDefectsDatas
					});
					
					//处理选中员工信息
					this.outputUserOptions = [{
						name: data.detailInfo.output_user_realname,
						value: data.detailInfo.output_user_id
					}];

					this.aux_unit = data.detailInfo.aux_unit;
					this.unit = data.detailInfo.unit;
					
					this.aux_unit_id = data.detailInfo.aux_unit_id;
					
					this.price = data.detailInfo.price || 0;
					this.salary = data.detailInfo.pre_salary || 0;
					this.unit_duration_count = data.detailInfo.unit_duration_count;
					this.unit_duration_hours = data.detailInfo.unit_duration_hours;
					this.unit_duration_minutes = data.detailInfo.unit_duration_minutes;

					this.initDefectsOption(data.defectsList);
					
					//已选中的通知用户列表
					this.notifySelectedUser = data.notifyUserList.map(item => {
						return {
							name:item.user_realname,
							value:item.id
						}
					});
					
					//如果是待提交
					if(data.detailInfo.state == 0){
						var state = 1;
						//判断是否有审批权限，如果有权限，则默认为已审批
						if(this.auth('b_output_audit')){
							state = 2;
						}
						this.$refs.outputForm.set({
							real_start_date: new Date().format('yyyy-MM-dd hh:mm'),
							real_end_date: new Date().format('yyyy-MM-dd hh:mm'),
							duration_hours:0,
							duration_minutes:0,
							state:state,
						});
					}
				}
			});
		},
		
		/*******按工序获取产品报工单位信息******/
		getAuxUnitInfo(process_id, product_id){
			//按选中的产品重新加载产品详细信息
			this.request({
				url:'/product/listSubUnit',
				data: {
					business_type: 3,
					process_id: process_id,
					product_ids: [product_id]
				},
				success: data => {
					//处理数据
					data.forEach(item => {
						this.aux_unit_id = item.aux_unit_id;
						this.aux_unit = item.aux_unit;
						this.aux_unit_count = item.aux_unit_count;
						
						this.aux_fine_count = parseFloat(((this.fine_count||0)/(item.aux_unit_count)).toFixed(6));
					});
				}
			});
		},

		/*******搜索【工单】下拉框信息*****************/
		searchWork(keyword, resolve){
			this.request({
				url:'/work/auth/optionList',
				data: {
					keyword:keyword
				},
				success:data => {
					var option = data.map(item => {
						return {
							name: item.work_code,
							value: item.id,
							data: item
						}
					});
					resolve(option);
				}
			})
		},
		
		/********变更工单下拉框数据*************/
		changeWork({data}){
			this.$refs.outputForm.set({
				product_code: data.product_code,
				product_name: data.product_name,
				product_spec: data.product_spec||'-'
			});
			this.unit = data.unit;
			this.work_state = data.work_state;
			this.initDefectsOption();
			//处理选中员工信息
			this.outputUserOptions = [{
				name: this.userInfo.user_realname,
				value: this.userInfo.id
			}];
			//默认计价方式
			this.pricing_type = this.userInfo.pricing_type;
			
			//根据工单加载任务选项列表
			this.initTaskOption();
			this.setLinkedData();
		},
		
		/********加载任务下拉框*************/
		initTaskOption(selectTaskData){
			this.taskOptions = [];
			this.request({
				url:'/task/auth/optionList',
				data: {
					work_id: this.work_id
				},
				success:data => {
					//处理可选任务工序下拉数据
					this.taskOptions = data.map(item => {
						return {
							name: item.process_code +'  |  ' +item.process_name,
							value: item.id,
							data: item
						}
					});
					if(!selectTaskData){
						if(this.taskOptions.length == 0){
							//没有可报工的工序
							this.$message({
							    message: '没有可报工的工序，请重新选择！'
							})
							return;
						}else{
							//获取默认填入的良品数
							let de_fine_count = this.getDefFineCount(this.taskOptions[0].data);
							
							//默认选中第一个任务工序
							this.outputType = 1;
							this.testMode = this.taskOptions[0].data.test_mode;
							this.$refs.outputForm.set({
								task_id: this.taskOptions[0].value,
								fine_count: de_fine_count,
								taskState: this.taskOptions[0].data.state
							});
							
							this.process_id = this.taskOptions[0].data.process_id;
							
							//初始化报工产品单位信息
							this.getAuxUnitInfo(this.taskOptions[0].data.process_id, this.taskOptions[0].data.product_id);
						}
					}else{
						if(this.taskOptions.length == 0){
							// //处理可选任务工序下拉数据
							this.taskOptions = [{
								name: selectTaskData.process_code +'  |  ' +selectTaskData.process_name,
								value: selectTaskData.task_id,
								data: selectTaskData
							}];
						}else{
							var is_exists = false;
							//判断是否存在要选中的任务
							this.taskOptions.forEach(item => {
								if(item.value == selectTaskData.task_id){
									is_exists = true;
								}
							});
							//不存在被选中项
							if(!is_exists){
								this.taskOptions.push({
									name: selectTaskData.process_code +'  |  ' +selectTaskData.process_name,
									value: selectTaskData.task_id,
									data: selectTaskData
								});
							}
						}
						
						//选中制定任务工序
						this.$refs.outputForm.set({
							task_id: selectTaskData.task_id,
							fine_count: selectTaskData.fine_count
						});
						
						this.process_id = selectTaskData.process_id;
						
						if(selectTaskData.product_id){
							//初始化报工产品单位信息
							this.getAuxUnitInfo(selectTaskData.process_id, selectTaskData.product_id);
						}
					}
				}
			});
		},
		
		/********变更任务工序下拉框数据*************/
		changeTask(selectData){
			this.process_id = selectData.data.process_id;
			
			//获取默认填入的良品数
			let de_fine_count = this.getDefFineCount(selectData.data);
			
			this.outputType = 1;
			this.testMode = selectData.data.test_mode;
			this.$refs.outputForm.set({
				fine_count: de_fine_count,
				aux_defects_count: 0,
				taskState: selectData.data.state
			});
			//根据工单加载任务可选不良品选项列表
			this.initDefectsOption();
			//处理选中员工信息
			this.outputUserOptions = [{
				name: this.userInfo.user_realname,
				value: this.userInfo.id
			}];
			
			//默认计价方式
			this.pricing_type = this.userInfo.pricing_type;
			
			//初始化报工产品单位信息
			this.getAuxUnitInfo(selectData.data.process_id, selectData.data.product_id);
			this.setLinkedData();
		},
		
		/********变更任务工序状态*************/
		changeTaskState(state){
			this.request({
				url:'/task/editState',
				data: {
					id: this.task_id,
					state: state
				},
				success:data => {
					this.$message({
						type: 'success',
						message:'任务状态变更成功',
					});
					//刷新任务列表数据
					this.$bus.$emit('task.list.update', {});
					//刷新报工列表数据
					this.$bus.$emit('output.list.update', {});
				}
			})
		
		},

		/*******搜索【员工】下拉框信息*****************/
		searchOutputUser(keyword, resolve){
			this.request({
				url:'/sys_user/auth_output/options/list',
				data: {
					task_id: this.task_id,
					keyword:keyword
				},
				success:data => {
					var option = data.map(item => {
						return {
							name: item.user_realname,
							value: item.id,
							data: item
						}
					});
					resolve(option);
				}
			})
		},
		
		/********加载不良品下拉框*************/
		initDefectsOption(defectsList){
			if (defectsList) {
				this.$refs.defectsList.setValueData(defectsList.map(item => {
					return {
						name: `${item.defects_name} (${item.item_count})`,
						value: item.id,
						data: item
					}
				}));
			} else {
				this.$refs.defectsList.set([]);
			}
		},

		/*******提交编辑数据********************/
		editHandle(stop, next) {
			stop();
			this.$refs.customForm.ready(() => {
				if (this.editState && this.salary == '-') return;
				this.$refs.outputForm.submit({
					url: this.editState ? '/output/edit':'/output/add',
					rule: {
						work_id: data =>{
							if(this.work_id == 0){
								return '请选择需要报工的工单'
							}else{
								return true;
							}
						},
						task_id: '请选择工序',
						taskState: data =>{
							if(!this.editState && this.taskState != 2){
								return '任务状态变更为【执行中】才允许报工'
							}else{
								return true;
							}
						},
						output_user_id: '请选择生产人员',
						aux_fine_count: '请输入良品数',
						fine_count: '请输入良品数',
						aux_defects_count: '请输入不良品数',
						defects_count: '请输入不良品数',
						counts: data =>{
							var flag = true;
							if(data.defects_count == 0 && data.fine_count == 0){
								return "「良品数」与「不良品数」不能同时为0";
							} 
							return flag||"请完善报工信息";
						},
						defects: data => {
							var flag = true;
							if((data.defects_count > 0 && data.defects_list.length == 0) || (data.defects_count == 0 && data.defects_list.length > 0)){
								return "不良品数、不良品项需同时填写";
							} 
							return flag||"请完善报工信息";
						},
						real_start_date: '请选择报工开始时间',
						real_end_date: '请选择报工结束时间',
						pricing_type:'请选择计价方式',
						duration_hours: '请输入报工时长',
						duration_minutes: '请输入报工时长',
						state:'请选择审核状态',
						...this.$refs.customForm.rule
					},
					dataFormatter: data => {
						data.id = this.output_id || 0;
						data.aux_unit_id = this.aux_unit_id;
						data.defects_list = this.$refs.defectsList.getData().map(item => {
							return {
								defects_id: item.value,
								defects_name: item.data.defects_name,
								item_count: item.data.item_count
							}
						});
						data.process_id = this.process_id;
						if (this.editState) {
							data.price = this.price;
							data.pre_salary = this.salary;
							data.unit_duration_count = this.unit_duration_count;
							data.unit_duration_hours = this.unit_duration_hours;
							data.unit_duration_minutes = this.unit_duration_minutes;
						}
						data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
						return data;
					},
					success: (data, res) => {
						next();
						this.$message({
							type: 'success',
							message:this.editState ? '编辑报工成功' : '创建报工成功',
						});
						//刷新页面
						this.$emit('resolve');
					}
				})
			})
		},
		
		/**************变更不良品数量******************/
		changeCount(rowData){
			if (rowData.item_count > 0){
				rowData._selected = true;
			}else{
				rowData._selected = false;
			}
		},

		editDefects(list, resolve) {
			this._editDefectsResolve = resolve;
			this.request({
				url:'/dic/process/defects/list',
				data: {
					process_id: this.process_id
				},
				loading: true,
				success: data => {
					data.forEach(item => {
						let temp = list.find(i => i.value == item.id);
						if (temp) {
							item.item_count = temp.data.item_count;
							item.selected = true;
						} else {
							item.item_count = '';
						}
					});
					this.$refs.defectsEdit.open();
					this.$refs.defectsEditList.setData(data);
				}
			})
		},

		editDefectsHandle(stop, next) {
			let data = this.$refs.defectsEditList.getData('selected');
			if (data.length && data.find(item => !item.item_count)) {
				this.$message({
					message: '请给选择的不良品项填写数量'
				});
				stop();
			}else{
				this._editDefectsResolve(data.map(item => {
					return {
						name: `${item.defects_name} (${item.item_count})`,
						value: item.id,
						data: item
					}
				}));
			}
		},

		/********获取报工单价信息*************/
		getOutputPriceConfig(data = this.$refs.outputForm.get()) {
			this._priceRequest && this._priceRequest.abort();
			if (this.process_id && data.work_id && data.task_id && data.pricing_type && data.output_user_id) {
				this._priceRequest = this.request({
					url: '/output/price/config',
					data: Object.assign({
						process_id: this.process_id
					}, data, {
						custom_fields_value_json: JSON.stringify(data.custom_fields_value_json)
					}),
					success: data => {
						this.price = data.price || 0;
						this.salary = data.pre_salary || 0;
						this.unit_duration_count = data.unit_duration_count;
						this.unit_duration_hours = data.unit_duration_hours;
						this.unit_duration_minutes = data.unit_duration_minutes;
					}
				});
			}
		},
		/********【变更】报工人*************/
		changeOutputUser(selectData){
			this.pricing_type = selectData.data.pricing_type; //计价方式（1：计件，2：计时）
			this.setLinkedData();
		},

		setLinkedData() {
			this.$refs.customForm.setDefaultData({
				work_type_id: 14,
				source_list: [[{
					ref_work_type_id: 3,
					ref_id: this.work_id
				}, {
					ref_work_type_id: 27,
					ref_id: this.output_user_id
				}]]
			});
		},

		/********【变更】报工计价方式*************/
		changeOutputPricingType(selectData){
			this.pricing_type = selectData;
		},
		
		/************搜索所有用户*******************************/
		searchNotifyUser(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'SYSUSER',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},
		
		/***************获取默认填入的良品数***********************/
		getDefFineCount(taskData){
			let de_fine_count = 0;
			if(!taskData){
				return de_fine_count;
			}
			//开启自动填入
			if(this.systemConfig.auto_input_fine_count && this.systemConfig.auto_input_fine_count == '1'){
				//限制报工顺序 && 并且存在前工序
				if(this.systemConfig.output_sort && this.systemConfig.output_sort == '1' && taskData.preTaskInfoDto){
					de_fine_count = (taskData.preTaskInfoDto.w_ok_count - taskData.w_fine_count)<0? 0:parseFloat(((taskData.preTaskInfoDto.w_ok_count - taskData.w_fine_count) * taskData.output_ratio).toFixed(2));
				}else{
					de_fine_count = (taskData.plan_count - taskData.fine_count)<0? 0:parseFloat((taskData.plan_count - taskData.fine_count).toFixed(6));
				}
				//未完成首检，并且可报工数>0
				if(taskData.firest_test_state == 1 && de_fine_count > 0){
					de_fine_count = 1;
				}
			}
			return de_fine_count;
		}
	}
}
</script>
<style lang="stylus" scoped>
	.output-tag {
		gap: 8px;
		margin-top: 8px;
		font-size: 12px;
		color: #666;

		div {
			height: 36px;
			padding: 0 12px;
			background: #FAFAFA;
		}
	}

	.salary-bar {
		height: 38px;
		padding: 0 12px;
		font-size: 13px;
		color: #666;
		background: #F6F6F6;

		i {
			margin-right: 6px;
			font-size: 18px;
		}

		ins {
			margin: 0 .6em;
		}
	}
</style>